__webpack_require__.p = "https://pgcoss.gzcmc.net/news-static/xinhuacheng/";